import { useEffect, useState } from "react";
import Layout from "../components/Layout";
import api from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "../components/ui/table";
import { Search, RefreshCw } from "lucide-react";

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [search, setSearch] = useState("");
  const reload = (q = {}) => api.get("/audit-logs", { params: q }).then((r) => setLogs(r.data));
  useEffect(() => { reload(); }, []);

  const filtered = logs.filter((l) =>
    !search ||
    [l.action_type, l.module_name, l.action_description, l.user_name, l.user_role, l.case_id]
      .some((x) => (x || "").toLowerCase().includes(search.toLowerCase())),
  );

  return (
    <Layout breadcrumbs={["SSRD", "Audit Logs"]}>
      <div className="mb-6">
        <div className="text-[10px] tracking-widest text-muted-foreground uppercase">Compliance</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight" data-testid="audit-title">Audit Logs</h1>
        <p className="text-sm text-muted-foreground">All system actions for SSRD case lifecycle.</p>
      </div>

      <Card><CardContent className="p-0">
        <div className="px-5 py-3 border-b border-border flex items-center gap-3">
          <div className="relative flex-1">
            <Search className="size-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <Input className="pl-9" placeholder="Filter by action, module, user…" value={search} onChange={(e) => setSearch(e.target.value)} data-testid="audit-search" />
          </div>
          <Button variant="outline" onClick={() => reload()} className="gap-2" data-testid="audit-refresh"><RefreshCw className="size-4" /> Refresh</Button>
        </div>
        <Table data-testid="audit-table">
          <TableHeader><TableRow>
            <TableHead>Time</TableHead><TableHead>User</TableHead><TableHead>Role</TableHead>
            <TableHead>Action</TableHead><TableHead>Module</TableHead>
            <TableHead>Case</TableHead><TableHead>Description</TableHead><TableHead>IP</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {filtered.length === 0 && <TableRow><TableCell colSpan={8} className="text-center text-sm text-muted-foreground py-8">No audit entries.</TableCell></TableRow>}
            {filtered.map((l) => (
              <TableRow key={l.audit_log_id}>
                <TableCell className="text-xs text-muted-foreground whitespace-nowrap">{(l.action_at || "").replace("T", " ").slice(0, 19)}</TableCell>
                <TableCell className="text-xs">{l.user_name || "—"}</TableCell>
                <TableCell className="text-xs">{l.user_role || "—"}</TableCell>
                <TableCell className="text-xs font-mono">{l.action_type}</TableCell>
                <TableCell className="text-xs">{l.module_name}</TableCell>
                <TableCell className="font-mono text-[10px]">{(l.case_id || "").slice(0, 8)}</TableCell>
                <TableCell className="text-xs max-w-md text-muted-foreground">{l.action_description}</TableCell>
                <TableCell className="text-[10px] font-mono text-muted-foreground">{l.ip_address}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent></Card>
    </Layout>
  );
}
